import axios from 'axios';

import {apiKey, backendUrl} from '../../config/config';

export const getContentsForUser = async (userId, tenantId) => {
  try {
    const {
      data: {
        tenantUrl,
        widgetTitle,
        priorityHeading,
        sections,
        teamIds,
        contentCounts,
        parentGroupId,
      },
    } = await axios.get(
      `${backendUrl}/beekeeper/${userId}/contents?tenantId=${tenantId}`,
      {
        headers: {
          'x-api-key': apiKey,
        },
      }
    );

    return {
      tenantUrl,
      widgetTitle,
      priorityHeading,
      sections,
      teamIds,
      parentGroupId,
      contentCounts,
    };
  } catch (e) {
    throw new Error(e);
  }
};
